export default {"src":"/_next/static/media/FB.9d27c29b.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};